export const AppIds = {
  INTERNAL_ADMIN: 'internal-admin',
  MERCHANT_ADMIN: 'merchant-admin',
  PORTALS: 'portals',
};
